module.exports = __webpack_public_path__ + "img/stock5.8c98f994.png";